export var VERSION = '1.9.1';
//# sourceMappingURL=version.js.map